import React from "react";
import './Loader.css'

const Loader = () => {
 
  return <div class="spinner"></div>;
};

export default Loader;
